import React from 'react';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

const PreviewBanner = React.forwardRef((props, ref) => {
    return (
        <div ref={ref} className="flex w-100 justify-center items-center preview-banner">
            <FontAwesomeIcon icon={faExclamationCircle} width={19} size='md' />
            <div>
                This is a preview. Do not share this link with clients.
            </div>
        </div>
    );
});

export default PreviewBanner;